import React from "react";
import { Navigate } from "react-router-dom";
import { isTokenValid } from "../utils/authUtils";

const ProtectedRoute = ({ element: Component, allowedRole }) => {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("role"); // admin or client

  // Check if token exists and is valid
  if (!isTokenValid()) {
    // No token - redirect to login
    return <Navigate to="/" replace />;
  }

  // Check if user role matches allowed role
  if (userRole === allowedRole) {
    return <Component />;
  } else {
    // Wrong role - redirect to access denied
    return <Navigate to="/access-denied" replace />;
  }
};

export default ProtectedRoute;